export default __webpack_public_path__ + "static/img2-5bdd0a3d4d25ce05c51996fb31675c3d.png";